/* =========================================================================
   HERMES — Bisglicinato de Magnesio NP · v1b · vanilla JS (no deps)
   ========================================================================= */
(function () {
  'use strict';
  var ROOT = document.querySelector('.hm-mgn');
  if (!ROOT) return;

  /* -----------------------------------------------------------------------
     0) ANTI-SPY + DESKTOP BLOCK
     ----------------------------------------------------------------------- */
  var caught = document.getElementById('hm-mgn-caught');
  var antiSpyOn = ROOT.classList.contains('hm-mgn--anti-spy');
  var desktopBlockOn = ROOT.classList.contains('hm-mgn--desktop-block');

  function showCaught(mode) {
    if (!caught) return;
    caught.classList.add('is-active');
    caught.setAttribute('data-hm-mgn-mode-active', mode);
    caught.querySelectorAll('.hm-mgn-caught__mode').forEach(function (m) {
      m.classList.toggle('is-shown', m.getAttribute('data-hm-mgn-mode') === mode);
    });
  }

  function isDesktopLike() {
    try {
      var wide = window.matchMedia('(min-width: 1024px)').matches;
      var hoverFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var noTouch = !('ontouchstart' in window) && navigator.maxTouchPoints === 0;
      return wide || hoverFine || noTouch;
    } catch (e) { return false; }
  }

  if (desktopBlockOn && isDesktopLike()) {
    showCaught('desktop');
  }

  if (antiSpyOn) {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
      if (!isDesktopLike()) showCaught('spy');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].indexOf(e.key.toUpperCase()) > -1)) {
        e.preventDefault();
        showCaught('spy');
      }
    });
    var devtoolsThreshold = 200;
    setInterval(function () {
      var wDelta = window.outerWidth - window.innerWidth;
      var hDelta = window.outerHeight - window.innerHeight;
      if ((wDelta > devtoolsThreshold || hDelta > devtoolsThreshold) && !isDesktopLike()) {
        showCaught('spy');
      }
    }, 1200);
  }

  /* If blocked, short-circuit the rest (no animations, no Releasit setup) */
  if (desktopBlockOn && isDesktopLike()) return;

  /* -----------------------------------------------------------------------
     1) PRELOADER — 0 → 100 + rotating words
     ----------------------------------------------------------------------- */
  (function preloader() {
    var pre = document.getElementById('hm-mgn-preloader');
    var counter = document.getElementById('hm-mgn-counter');
    var bar = document.getElementById('hm-mgn-bar');
    var words = document.querySelectorAll('.hm-mgn-pw');
    if (!pre) return;
    var n = 0;
    var wIdx = 0;
    var interval = setInterval(function () {
      n += Math.ceil(Math.random() * 9) + 3;
      if (n >= 100) n = 100;
      if (counter) counter.textContent = n;
      if (bar) bar.style.width = n + '%';
      if (n >= 100) {
        clearInterval(interval);
        setTimeout(function () {
          pre.classList.add('is-done');
          document.dispatchEvent(new CustomEvent('hmmgn:preloaderDone'));
        }, 260);
      }
    }, 110);
    if (words.length) {
      setInterval(function () {
        words[wIdx].classList.remove('active');
        wIdx = (wIdx + 1) % words.length;
        words[wIdx].classList.add('active');
      }, 650);
    }
  })();

  /* -----------------------------------------------------------------------
     2) WordsPullUp — hero headline (Prisma Creative Studio pattern)
     ----------------------------------------------------------------------- */
  document.querySelectorAll('[data-pullup]').forEach(function (el) {
    var text = el.getAttribute('data-pullup') || '';
    var words = text.split(' ').filter(Boolean);
    el.innerHTML = '';
    words.forEach(function (w, i) {
      var span = document.createElement('span');
      span.className = 'hm-mgn-pullup__word';
      span.style.transitionDelay = (i * 0.06) + 's';
      span.textContent = w;
      el.appendChild(span);
      el.appendChild(document.createTextNode(' '));
    });
  });
  setTimeout(function () {
    document.querySelectorAll('.hm-mgn-pullup__word').forEach(function (w) {
      w.classList.add('is-in');
    });
  }, 350);

  /* -----------------------------------------------------------------------
     3) IntersectionObserver generic reveal (stats, dotbox, bento)
     ----------------------------------------------------------------------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.25 });
  document.querySelectorAll('.hm-mgn-stat, .hm-mgn-dotbox').forEach(function (el) { io.observe(el); });

  /* -----------------------------------------------------------------------
     4) Rotating words — full-bleed cycling (role-fade)
     ----------------------------------------------------------------------- */
  (function rotator() {
    var words = document.querySelectorAll('.hm-mgn-rotator__word');
    if (!words.length) return;
    var idx = 0;
    setInterval(function () {
      words[idx].classList.remove('active');
      idx = (idx + 1) % words.length;
      words[idx].classList.add('active');
    }, 2000);
  })();

  /* -----------------------------------------------------------------------
     5) Sticky CTA — dual IntersectionObserver (hero out / final in)
     ----------------------------------------------------------------------- */
  (function stickyCta() {
    var sticky = document.querySelector('[data-hm-mgn-sticky]');
    var heroCta = document.querySelector('.hm-mgn-hero__cta');
    var finalCta = document.getElementById('hm-mgn-cta-final');
    if (!sticky) return;
    var heroVisible = true;
    var finalVisible = false;

    function sync() {
      sticky.classList.toggle('is-visible', !heroVisible && !finalVisible);
    }
    if (heroCta) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { heroVisible = e.isIntersecting; sync(); });
      }, { threshold: 0 }).observe(heroCta);
    }
    if (finalCta) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { finalVisible = e.isIntersecting; sync(); });
      }, { rootMargin: '0px 0px -40% 0px' }).observe(finalCta);
    }
  })();

  /* -----------------------------------------------------------------------
     6) CTA proxy click → dispara el botón Releasit real
     Orden de selectores (regla actualizada 2026-07-02):
       #rsi_buy_now_button (real en producción) → floating → inline legacy
     Con reintentos poll 300ms x 20 y secuencia de eventos completa.
     ----------------------------------------------------------------------- */
  var RSI_SELECTORS = ['#rsi_buy_now_button', '._rsi-buy-now-button-floating', '._rsi-buy-now-button:not(._rsi-buy-now-button-floating)'];

  function findReleasitButton() {
    for (var i = 0; i < RSI_SELECTORS.length; i++) {
      var el = document.querySelector(RSI_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function fireClickSequence(el) {
    ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(function (type) {
      try {
        el.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));
      } catch (e) { /* noop */ }
    });
  }

  function triggerReleasit(fallbackFormId) {
    var attempts = 0;
    var maxAttempts = 20;
    var poll = setInterval(function () {
      attempts++;
      var btn = findReleasitButton();
      if (btn) {
        clearInterval(poll);
        fireClickSequence(btn);
        console.info('[HERMES mgn] Releasit button detectado y disparado:', btn);
        return;
      }
      if (attempts >= maxAttempts) {
        clearInterval(poll);
        console.warn('[HERMES mgn] Releasit no detectado tras ' + (maxAttempts * 300) + 'ms — fallback: submit del form nativo oculto');
        var fallback = document.getElementById(fallbackFormId || 'hm-mgn-rsi-fallback-submit');
        if (fallback) fallback.click();
      }
    }, 300);
  }

  /* Hero + sticky CTA son anchors nativos a #hm-mgn-cta-final (regla actualizada 2026-07-09):
     Releasit requiere un click TRUSTED (isTrusted:true) sobre el elemento con sus propias
     hook classes para abrir el modal — un dispatchEvent sintetico desde un proxy JS NO
     lo abre (confirmado empiricamente). Por eso hero/sticky solo hacen scroll nativo hasta
     el boton final, que es el UNICO elemento con las hook classes _rsi-cod-form-pagefly-*,
     y el usuario lo toca directamente ahi. triggerReleasit()/fireClickSequence quedan como
     utilidad de diagnostico, sin uso activo por ahora. */

  /* -----------------------------------------------------------------------
     7) Kill Releasit floating button dinámicamente (por si CSS no atrapa clase nueva)
     ----------------------------------------------------------------------- */
  (function killFloating() {
    var tries = 0;
    var maxTries = 48; /* 24s @ 500ms */
    var iv = setInterval(function () {
      tries++;
      document.querySelectorAll('._rsi-buy-now-button-floating, [class*="_rsi-buy-now"][class*="floating"], [class*="_rsi-floating"]').forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      });
      if (tries >= maxTries) clearInterval(iv);
    }, 500);
  })();

  /* -----------------------------------------------------------------------
     8) Releasit submit skin — vence inline styles !important del merchant
     ----------------------------------------------------------------------- */
  (function releasitSubmitSkin() {
    function skin(el) {
      if (!el) return;
      el.style.setProperty('background', 'linear-gradient(135deg, #C17A4D, #E2A06B)', 'important');
      el.style.setProperty('color', '#000000', 'important');
      el.style.setProperty('border-radius', '999px', 'important');
      el.style.setProperty('border', 'none', 'important');
      el.style.setProperty('font-weight', '700', 'important');
      el.style.setProperty('min-height', '54px', 'important');
      el.style.setProperty('width', '100%', 'important');
    }
    function sweep() {
      document.querySelectorAll('[class*="_rsi"][class*="submit"], [class*="_rsi-cod-form"] button[type="submit"], [class*="_rsi-modal"] button').forEach(skin);
    }
    sweep();
    var mo = new MutationObserver(sweep);
    mo.observe(document.body, { childList: true, subtree: true });
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      sweep();
      if (tries >= 80) clearInterval(iv); /* ~40s @ 500ms */
    }, 500);
    document.addEventListener('click', function () { setTimeout(sweep, 60); });
  })();

  console.info('[HERMES mgn] chassis ready');
})();
